import React from 'react';
import { services } from '../../mockData';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wider">We Are Specialists In</span>
          <h2 className="text-4xl font-bold text-gray-800 mt-2">What We Do</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative">
          {/* First 3 services */}
          {services.slice(0, 3).map((service) => (
            <div
              key={service.id}
              className="text-center group hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="mb-4 flex justify-center">
                <img src={service.icon} alt={service.title} className="h-16 w-16" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-yellow-500 transition-colors">
                <Link to="/services">{service.title}</Link>
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}

          

          {/* Last 3 services */}
          {services.slice(3, 6).map((service) => (
            <div
              key={service.id}
              className="text-center group hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="mb-4 flex justify-center">
                <img src={service.icon} alt={service.title} className="h-16 w-16" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-yellow-500 transition-colors">
                <Link to="/services">{service.title}</Link>
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;